if (typeof hlfCardInitialized === 'undefined') {
  document.addEventListener('click', function (e) {
    // Add to Cart Logic
    const cartBtn = e.target.closest('[data-add-to-cart]');
    if (cartBtn && !cartBtn.disabled) {
      e.preventDefault();
      const variantId = cartBtn.dataset.variantId;
      if (!variantId) return;

      cartBtn.classList.add('is-loading');
      cartBtn.disabled = true;

      // Mirror Dawn's product-form.js exactly
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      if (cart) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(cartBtn);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error('Cart Error:', response.description);
            return;
          } else if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          });

          cart.renderContents(response);

          const text = cartBtn.querySelector('.hlf-btn-text');
          if (text) {
            const original = text.textContent;
            text.textContent = '✓ Added!';
            setTimeout(() => { text.textContent = original; }, 2000);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          cartBtn.classList.remove('is-loading');
          cartBtn.disabled = false;
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
    }

    // Wishlist Logic
    const wishBtn = e.target.closest('[data-wishlist-btn]');
    if (wishBtn) {
      e.preventDefault();
      wishBtn.classList.toggle('is-wishlisted');
      const productId = wishBtn.dataset.productId;
      document.dispatchEvent(new CustomEvent('hlf:wishlist:toggle', {
        detail: { productId, isWishlisted: wishBtn.classList.contains('is-wishlisted') }
      }));
    }
  });
  window.hlfCardInitialized = true;
}
